/**
 * Tính lương ghi `calculatedAt` lúc save cuối. Kỳ đã calculated từ lần trước
 * vẫn giữ status đó trong lúc tính lại, nên không dùng status làm dấu hoàn tất.
 */
export const isPayrollCalculationFinished = (
  period: { status: string; calculatedAt?: string | null },
  calculatedAtBefore: string | null | undefined
): boolean => {
  if (period.status !== 'calculated' || !period.calculatedAt) return false;
  if (!calculatedAtBefore) return true;
  const next = Date.parse(period.calculatedAt);
  const prev = Date.parse(calculatedAtBefore);
  if (!Number.isFinite(next) || !Number.isFinite(prev)) return false;
  return next > prev;
};
